export enum TabQueryParam {
  OrgSettings = 'organization',
  LoginSettings = 'login',
  NotificationSettings = 'notification',
  ApiKeySettings = 'apiKey',
  AuditLogs = 'auditLogs',
}
